import KaKaoIcon from '@/assets/icons/More/payment_icon_yellow_large 1.svg?react';
import { Dialog, DialogTrigger, DialogContent } from '@/components/atoms/Dialog';
import { useState } from 'react';
import ChangeBillCard from '@/pages/More/ChangeBillCard';
import ChangeBillKakao from '@/pages/More/ChangeBillKakao';

interface NewPaymentDialogProps {
  isPrePayment?: boolean;
  subscriptionNo: number;
  paymentAmount: number;
  setBillDialogOpen: (open: boolean) => void;
}
const NewPaymentDialog = ({
  isPrePayment,
  subscriptionNo,
  paymentAmount,
  setBillDialogOpen,
}: NewPaymentDialogProps) => {
  const [changeBillOptions, setChangeBillOptions] = useState<'KAKAO_PAY' | 'CARD'>('KAKAO_PAY');

  const billProps = {
    isPrePayment,
    subscriptionNo,
    paymentAmount,
    setBillDialogOpen,
  };
  const renderChangeBillForm = () => {
    switch (changeBillOptions) {
      case 'KAKAO_PAY':
        return <ChangeBillKakao {...billProps} />;
      case 'CARD':
        return <ChangeBillCard {...billProps} />;
      default:
        return <ChangeBillKakao {...billProps} />;
    }
  };
  return (
    <DialogContent noCloseBtn className="w-full max-w-[580px]">
      <div className="flex flex-col items-start gap-8">
        <div className="flex w-full flex-col gap-3">
          <h1 className="text-gr-900 Body1S16">결제 수단</h1>
          <div className="flex w-full items-start justify-between">
            <div className="pt-[11px] text-gr-800 Body2M16">변경할 결제 수단</div>
            <div className="flex h-[46px] rounded-[12px] bg-gr-100 p-[6px]">
              {/* 카카오페이 */}
              <div
                className={`flex w-[140px] cursor-pointer items-center justify-center gap-[6px] rounded-[8px] transition
                  ${changeBillOptions === 'KAKAO_PAY' ? 'bg-white shadow' : 'bg-gr-100'}
                `}
                onClick={() => setChangeBillOptions('KAKAO_PAY')}
              >
                <KaKaoIcon />
                <span className="text-gr-700 Body5M14">카카오페이</span>
              </div>
              {/* 카드결제 */}
              <div
                className={`flex w-[140px] cursor-pointer items-center justify-center gap-[6px] rounded-[8px] transition
                  ${changeBillOptions === 'CARD' ? 'bg-white shadow' : 'bg-gr-100'}
                `}
                onClick={() => setChangeBillOptions('CARD')}
              >
                <span className="text-gr-700 Body5M14">일반 카드</span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full transition-all">{renderChangeBillForm()}</div>
      </div>
    </DialogContent>
  );
};

export default NewPaymentDialog;
